<ng-container *ngIf="!!details">
  <div class="content-container">
    <div class="full-bleed section-image" *ngIf="details.image">
      <img [src]="details.image" alt="" />
    </div>
    <div id="banner" class="section text-block section-heading">
      <h1 class="heading" [style.background-image]="details.safeImage">
        {{ details.title }}
        <button *ngIf="!details.selected" (click)="toggleSelected()" [disabled]="formSubmitted">
          {{ locale.selectButtonText }}
        </button>
        <button
          *ngIf="details.selected"
          (click)="toggleSelected()"
          class="selected"
          [disabled]="formSubmitted"
        >
          {{ locale.deselectButtonText }}
        </button>
      </h1>

      <div class="intro-wrapper">
        <p class="intro-text normal" [innerHtml]="details.introText | parseFormattedText"></p>
        <btn-dropdown
          *ngIf="dcdLoaded"
          (clickedItem)="clickedItem($event)"
          (click)="$event.stopPropagation();"
          listTitle="DCD"
          image="assets/images/MFC-Logo-Greyscale.png"
          [parentId]="id"
          [items]="relatedDcd.articles ? relatedDcd.articles : []"
        ></btn-dropdown>
      </div>

      <div id="side-bar-details">
        <div
          class="section "
          data-step="3"
          [attr.data-intro]="locale.overlayGraduate"
          data-scrollTo="tooltip"
        >
          <div class="section divided columnar" *ngIf="chartSection">
            <h3>{{ chartSection.header }}</h3>
            <ng-container *ngIf="graphReady">
              <doughnut-chart
                [datasets]="datasets"
                [labels]="doughnutChartLabels"
                [colors]="chartColors"
                [options]="options"
                (onChartHover)="chartHovered($event)"
                (onChartClick)="chartClicked($event)"
              >
              </doughnut-chart>
            </ng-container>
            <p class="normal chart-paragraph">
              {{ chartSection.text }}
            </p>
            <p class="light">*{{ locale.source }}:&nbsp;{{ chartSection.source }}</p>
          </div>

          <ng-container class="columnar" *ngFor="let row of textEntrance">
            <div class="section divided hug-top">
              <h4>{{ row.header }}</h4>
              <p class="normal light" [innerHtml]="row.text | parseFormattedText"></p>
            </div>
          </ng-container>

          <ng-container class="columnar" *ngFor="let row of textCareers">
            <div class="section divided hug-top">
              <h4>{{ row.header }}</h4>
              <p class="normal light" [innerHtml]="row.text | parseFormattedText"></p>
              <ul class="bullet-list">
                <li *ngFor="let datum of row.data">
                  {{ datum.value }}
                </li>
              </ul>
            </div>
          </ng-container>

          <ng-container class="columnar" *ngFor="let row of textCourses">
            <div class="section divided hug-top">
              <h4>{{ row.header }}</h4>
              <p class="normal light" [innerHtml]="row.text | parseFormattedText"></p>
              <ul class="bullet-list">
                <li *ngFor="let datum of row.data">
                  {{ datum.value }}
                </li>
              </ul>
            </div>
          </ng-container>
        </div>
      </div>
      <!-- #/side-bar-details -->
    </div>

    <div
      class="section text-block course-details"
      data-step="2"
      [attr.data-intro]="locale.overlayMatch"
      data-scrollTo="tooltip"
    >
      <div>
        <div>
          <h4>
            {{ locale.interestHeaderText | stringFormat: [details.title] }}
          </h4>
          <div class="columnar">
            <div>
              <p class="normal light">
                {{ locale.interestText | stringFormat: [details.interestDesc, details.title] }}
              </p>
            </div>
            <div>
              <rating-bar [percentage]="details.interest"></rating-bar>
            </div>
          </div>
        </div>
      </div>

      <div class="indent" *ngFor="let matchData of matchSection.data">
        <div>
          <h4 class="dark">
            {{ matchData.key }}
          </h4>
          <div class="columnar">
            <div>
              <p class="normal light __expanded">
                {{ matchData.description }}
              </p>
            </div>
            <div>
              <rating-bar [percentage]="matchData.value"></rating-bar>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div>
          <h4>
            Overall match
          </h4>
          <div class="columnar">
            <div>
              <p class="normal light">
                {{ locale.overallMatchText | stringFormat: [details.matchDesc] }}
              </p>
            </div>
            <div>
              <rating-bar [percentage]="details.match"></rating-bar>
            </div>
          </div>
        </div>
      </div>

      <div class="columnar textSections single-col">
        <ng-container class="columnar" *ngFor="let row of textCautionary">
          <h4>{{ row.header }}</h4>
          <p class="normal light">{{ locale.cautionaryNotesIntro }}</p>
          <div class="list">
            <div class="full-width" *ngFor="let datum of row.data">
              <h4 class="dark">{{ datum.key }}</h4>
              <p class="normal light">{{ datum.value }}</p>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="columnar textSections single-col">
        <ng-container class="columnar" *ngFor="let row of textWebsites">
          <h4 class="margin-bottom">{{ row.header }}</h4>
          <p class="normal light dark-links" [innerHtml]="row.text | parseFormattedText"></p>
        </ng-container>
      </div>

      <div class="columnar textSections single-col extra-margin-bottom">
        <ng-container class="columnar" *ngFor="let row of textReading">
          <h4 class="margin-bottom">{{ row.header }}</h4>
          <p class="normal light" [innerHtml]="row.text | parseFormattedText"></p>
        </ng-container>
      </div>

      <!-- side-bar mobile view -->
      <div
        id="side-bar-details-mobile"
        data-step="3"
        [attr.data-intro]="locale.overlayGraduate"
        data-scrollTo="tooltip"
      >
        <div class="columnar">
          <div class="section divided" *ngIf="chartSection">
            <h3>{{ chartSection.header }}</h3>
            <div *ngIf="graphReady">
              <doughnut-chart
                [datasets]="datasets"
                [labels]="doughnutChartLabels"
                [colors]="chartColors"
                [options]="options"
                (onChartHover)="chartHovered($event)"
                (onChartClick)="chartClicked($event)"
              >
              </doughnut-chart>
            </div>
            <div>
              <p class="normal chart-paragraph">
                {{ chartSection.text }}
              </p>
              <p class="light">*{{ locale.source }}:&nbsp;{{ chartSection.source }}</p>
            </div>
          </div>

          <div class="section divided hug-top">
            <ng-container class="columnar" *ngFor="let row of textCautionary">
              <h4>{{ row.header }}</h4>
              <p class="normal light">{{ locale.cautionaryNotesIntro }}</p>
              <div *ngFor="let datum of row.data">
                <h4 class="dark margin-top">{{ datum.key }}</h4>
                <p class="normal light">{{ datum.value }}</p>
              </div>
            </ng-container>
          </div>

          <ng-container class="columnar" *ngFor="let row of textCareers">
            <div class="section divided hug-top">
              <h4>{{ row.header }}</h4>
              <p class="normal light" [innerHtml]="row.text | parseFormattedText"></p>
              <ul class="bullet-list">
                <li *ngFor="let datum of row.data">
                  {{ datum.value }}
                </li>
              </ul>
            </div>
          </ng-container>

          <ng-container class="columnar" *ngFor="let row of textCourses">
            <div class="section divided hug-top">
              <h4>{{ row.header }}</h4>
              <p class="normal light" [innerHtml]="row.text | parseFormattedText"></p>
              <ul class="bullet-list">
                <li *ngFor="let datum of row.data">
                  {{ datum.value }}
                </li>
              </ul>
            </div>
          </ng-container>

          <ng-container class="columnar" *ngFor="let row of textEntrance">
            <div class="section divided hug-top">
              <h4>{{ row.header }}</h4>
              <p class="normal light" [innerHtml]="row.text | parseFormattedText"></p>
            </div>
          </ng-container>

          <ng-container class="columnar" *ngFor="let row of textWebsites">
            <div class="section divided hug-top">
              <h4 class="margin-bottom">{{ row.header }}</h4>
              <p class="normal light dark-links" [innerHtml]="row.text | parseFormattedText"></p>
            </div>
          </ng-container>

          <ng-container class="columnar" *ngFor="let row of textReading">
            <div class="section divided hug-top extra-margin-bottom">
              <h4 class="margin-bottom">{{ row.header }}</h4>
              <p class="normal light" [innerHtml]="row.text | parseFormattedText"></p>
            </div>
          </ng-container>
        </div>
      </div>
      <!-- side-bar mobile view -->
    </div>
  </div>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/components/course-areas/detail/course-area-detail/course-area-detail.component.html